import { useSEO } from '@/hooks/useSEO';
import FoodHero from "./components/FoodHero";
import FoodOverview from "./components/FoodOverview";
import FoodProducts from "./components/FoodProducts";
import FoodProcess from "./components/FoodProcess";
import FoodGallery from "./components/FoodGallery";
import FoodInquiry from "./components/FoodInquiry";
import Footer from "@/pages/home/components/Footer";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const FOOD_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Food Processing Equipment Installation Kenya",
    "url": SITE_URL + "/food-processing",
    "description": "Food processing equipment supply and installation in Kenya — grain mills, conveyors, bucket elevators, storage silos and dehumidification systems. HACCP-aware installations by ISMAN Engineering.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL,
      "telephone": "+254724114555"
    },
    "areaServed": { "@type": "Country", "name": "Kenya" },
    "serviceType": "Food Processing Equipment"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Food Processing", "item": SITE_URL + "/food-processing" }
    ]
  }
];

export default function FoodProcessingPage() {
  useSEO({
    title: 'Food Processing Equipment Installation Kenya | Grain Mills Conveyors | ISMAN',
    description: 'Food processing equipment installation in Kenya — grain mills, conveyors, elevators, storage silos and dehumidification systems. HACCP-compliant installations by ISMAN Engineering Nairobi.',
    keywords: 'food processing equipment Kenya, grain mill installation Kenya, conveyor systems Kenya, food grade equipment Nairobi, storage silo Kenya',
    canonical: SITE_URL + '/food-processing',
    schema: FOOD_SCHEMA,
  });

  return (
    <main className="min-h-screen bg-white">
      <FoodHero />
      <FoodOverview />
      <FoodProducts />
      <FoodProcess />
      <FoodGallery />
      <FoodInquiry />
      <Footer />
    </main>
  );
}
